/** Sample agenda photos for the Flow 9 simulation. */

function canvasUrl(width, height, draw) {
  if (typeof document === "undefined") return "";
  const canvas = document.createElement("canvas");
  canvas.width = width;
  canvas.height = height;
  const ctx = canvas.getContext("2d");
  if (!ctx) return "";
  draw(ctx, width, height);
  return canvas.toDataURL("image/png");
}

function page(ctx, width, height, title) {
  ctx.fillStyle = "#F7F4EC";
  ctx.fillRect(0, 0, width, height);
  ctx.fillStyle = "#1F3A2E";
  ctx.fillRect(0, 0, width, 72);
  ctx.fillStyle = "#FFFFFF";
  ctx.font = "700 28px Segoe UI, sans-serif";
  ctx.fillText(title, 28, 46);
}

function line(ctx, y, text, strong) {
  ctx.fillStyle = "#122118";
  ctx.font = `${strong ? 700 : 500} 24px Segoe UI, sans-serif`;
  ctx.fillText(text, 32, y);
}

let weekUrl = "";
let dayUrl = "";
let taskUrl = "";

export function weekAgendaUrl() {
  if (weekUrl) return weekUrl;
  weekUrl = canvasUrl(720, 640, (ctx, width, height) => {
    page(ctx, width, height, "Agenda — semaine");
    line(ctx, 130, "Semaine du 13 au 17 octobre", true);
    line(ctx, 210, "Mer. 14   Français", true);
    line(ctx, 248, "Rédaction « Mon quartier » · à remettre");
    line(ctx, 330, "Jeu. 15   Sciences", true);
    line(ctx, 368, "Rapport de labo · avant 16 h");
    line(ctx, 450, "Ven. 16   Maths", true);
    line(ctx, 488, "Examen sur les fonctions · 9 h");
  });
  return weekUrl;
}

export function dayAgendaUrl() {
  if (dayUrl) return dayUrl;
  dayUrl = canvasUrl(720, 480, (ctx, width, height) => {
    page(ctx, width, height, "Agenda — jeudi");
    line(ctx, 130, "Jeudi 15 octobre", true);
    line(ctx, 220, "15 h   Histoire", true);
    line(ctx, 258, "Questions p. 84 · à remettre");
    line(ctx, 340, "16 h   Sciences", true);
    line(ctx, 378, "Rapport de labo · à remettre");
  });
  return dayUrl;
}

export function taskAgendaUrl() {
  if (taskUrl) return taskUrl;
  taskUrl = canvasUrl(720, 560, (ctx, width, height) => {
    page(ctx, width, height, "Fiche — Anglais");
    line(ctx, 140, "Oral sur le roman", true);
    line(ctx, 210, "Lundi 19 octobre · 10 h");
    line(ctx, 270, "Durée : 5 minutes");
    line(ctx, 330, "Chapitres 1 à 3");
    line(ctx, 400, "Présenter le personnage principal.");
  });
  return taskUrl;
}

export function matchAgenda(src) {
  if (src && src === weekAgendaUrl()) return "week";
  if (src && src === dayAgendaUrl()) return "day";
  if (src && src === taskAgendaUrl()) return "task";
  return "";
}
